export default "__VITE_ASSET__BgQydxBR__"